import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="case_studies" pageTitle="案例研究" pageDescription="QbD Group如何帮助生命科学公司应对监管挑战并加速市场推出的真实案例。" />;

export const Route = createFileRoute("/zh-cn/case-studies/")({
  head: () => buildRouteHead("/zh-cn/case-studies"),
  component: ContentListingRoute,
});

